import { breakpoints, displays } from '@/utils'

const scrollBarWidth = 16

let timeout

export default {
  namespaced: true,

  state: {
    viewport: {
      breakpoint: {
        xs: false,
        sm: false,
        smUp: false,
        smDown: false,
        md: false,
        mdUp: false,
        mdDown: false,
        lg: false,
        lgUp: false,
        lgDown: false,
        xl: false
      },
      size: {
        height: 0,
        width: 0
      }
    },

    display: displays.desktop
  },

  mutations: {
    setSize(state) {
      const width = window.innerWidth

      const xs = width < breakpoints.xs
      const sm = width < breakpoints.sm && !xs
      const md = width < breakpoints.md - scrollBarWidth && !(sm || xs)
      const lg = width < breakpoints.lg - scrollBarWidth && !(md || sm || xs)
      const xl = width >= breakpoints.lg - scrollBarWidth

      state.viewport.breakpoint.xs = xs

      state.viewport.breakpoint.sm = sm
      state.viewport.breakpoint.smUp = !xs && (sm || md || lg || xl)
      state.viewport.breakpoint.smDown = (xs || sm) && !(md || lg || xl)

      state.viewport.breakpoint.md = md
      state.viewport.breakpoint.mdUp = !(xs || sm) && (md || lg || xl)
      state.viewport.breakpoint.mdDown = (xs || sm || md) && !(lg || xl)

      state.viewport.breakpoint.lg = lg
      state.viewport.breakpoint.lgUp = !(xs || sm || md) && (lg || xl)
      state.viewport.breakpoint.lgDown = (xs || sm || md || lg) && !xl

      state.viewport.breakpoint.xl = xl

      state.viewport.size.height = window.innerHeight
      state.viewport.size.width = width
    },

    setDisplay(state, value) {
      state.display = displays.desktop
      if (value) {
        state.display = displays.mobile
      }
    }
  },

  actions: {
    init({ dispatch }) {
      window.addEventListener('resize', () => {
        return dispatch('onResize')
      }, { passive: true })
      dispatch('setSize')
      dispatch('setDisplay')
    },

    onResize({ dispatch }) {
      clearTimeout(timeout)
      timeout = window.setTimeout(() => {
        return dispatch('setSize')
      }, 200)
    },

    setSize({ commit }) {
      commit('setSize')
    },

    setDisplay({ commit }) {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      commit('setDisplay', isMobile)
    }
  },

  getters: {
    viewport: state => {
      return state.viewport
    },
    display: state => {
      return state.display
    }
  }
}
